import {GiNotebook} from 'react-icons/gi';
import {BiMessageDetail} from 'react-icons/bi';
import {AiFillSafetyCertificate} from 'react-icons/ai';

const featuresData = [
    {
      id: 1,
      title: "Quick Learning",
      desc: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nostrum molestias, aperiam doloribus aut sapiente praesentium eos iste dicta amet itaque!",
      icon: <GiNotebook />,
    },
  
    {
      id: 2,
      title: "All Time Support",
      desc: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nostrum molestias, aperiam doloribus aut sapiente praesentium eos iste dicta amet itaque!",
      icon: <BiMessageDetail />,
    },
  
    {
      id: 3,
      title: "Certification",
      desc: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nostrum molestias, aperiam doloribus aut sapiente praesentium eos iste dicta amet itaque!",
      icon: <AiFillSafetyCertificate />,
    },
  ];

  export default featuresData;